import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './LayoutColumn.module.css';

const bindClasses = classNameBind.bind(styles);

const LayoutColumn = ({
  children,
  dominant,
}) => (
  <div
    className={bindClasses('wrapper', { dominant })}
    data-ppuc-id="LayoutColumn"
  >
    {children}
  </div>
);

LayoutColumn.defaultProps = {
  children: null,
  dominant: false,
};

LayoutColumn.displayName = 'Layout.Column';

export default LayoutColumn;
